export default __webpack_public_path__ + "static/media/IconDesc_PipeMK2.256.1cd40363.png";